export enum Platform {
  VRIJWILLIGERSWERK = 1,
  WELDOENERS = 2,
}
